// StorySection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../../assets/css/customer/subscreens/about/StorySection.css";

const StorySection = () => {
  return (
    <section className="story-section">
      <Container>
        <Row className="story-content">
          <Col lg={6} md={12} className="story-text">
            <h2 className="About-section-title">Our Story</h2>
            <p className="story-description">
              We noticed that talented Pakistani artisans did not have a proper
              platform to sell their handmade products. Most of them only used
              social media, with no easy way to reach more customers.
            </p>
            <p className="story-description">
              That gap is why we started CraftHive — a marketplace that connects
              sellers across Pakistan with buyers who value handmade work. Chat
              directly with sellers, customize your order, and pay through Cash
              on Delivery.
            </p>
            <p className="story-description">
              We believe in supporting local artisans, promoting craftsmanship,
              and making handmade shopping simple and trustworthy.
            </p>
          </Col>
          <Col lg={6} md={12} className="story-image">
            <img
              src="https://i.pinimg.com/736x/bc/33/46/bc33469f6ef02ef15e6fa59a0277675f.jpg"
              alt="Handmade crafts"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default StorySection;
